module.exports = __webpack_public_path__ + "img/agency-vip-templates.089330b2.svg";